import __vue_normalize__ from '@gig/magic-wand/dist/build/rollup/vue-helpers/normalize-component.js';
import script from './keycloak-configure-otp.js';

/* script */
const __vue_script__ = script;

/* template */
var __vue_render__ = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return (!_vm.shouldSkip)?_c('div',[_c('form',{ref:"form",staticStyle:{"display":"none"},attrs:{"action":_vm.configureOtpAction,"method":"post"}},[_c('input',{attrs:{"id":"phone_prefix","name":"phone_prefix","autocomplete":"off"}}),_vm._v(" "),_c('input',{attrs:{"id":"phone_number","name":"phone_number","autocomplete":"off"}})]),_vm._v(" "),(_vm.formConfig)?_c('magic-form-builder',{domProps:{"config":_vm.formConfig},on:{"form-submit":function($event){return _vm.submit($event.detail[0])}}}):_vm._e()],1):_vm._e()};
var __vue_staticRenderFns__ = [];

  /* style */
  const __vue_inject_styles__ = undefined;
  /* scoped */
  const __vue_scope_id__ = undefined;
  /* module identifier */
  const __vue_module_identifier__ = undefined;
  /* functional template */
  const __vue_is_functional_template__ = false;
  /* style inject */
  
  /* style inject SSR */
  
  /* style inject shadow dom */
  

  
  const __vue_component__ = /*#__PURE__*/__vue_normalize__(
    { render: __vue_render__, staticRenderFns: __vue_staticRenderFns__ },
    __vue_inject_styles__,
    __vue_script__,
    __vue_scope_id__,
    __vue_is_functional_template__,
    __vue_module_identifier__,
    false,
    undefined,
    undefined,
    undefined
  );

export default __vue_component__;
